import { bindUrl, request } from "./request";

export function uploadFile(bodyParams) {
  return request({
    url: bindUrl("/blade-resource/oss/endpoint/put-file?code=ali-oss-p", {}),
    headers: { "Content-Type": "multipart/form-data" },
    method: "POST",
    data: bodyParams
  });
}
